import { createI18n } from 'vue-i18n';

const messages = {

  es: {   
      comun: {        
        boton_exportar: "Exportar",
        boton_importar: "Importar",
        cargar_datos:"Cargar datos",
        guardar_datos:"Guardar",
        guardar_caso_base:"Guardar caso base",
        boton_ok: "OK",
        boton_cancelar: "Cancelar",
        "si":"Sí",
        "no":"No",
        "aplicar": "Aplicar",
        "horizonte":"Horizonte",
        "texto_horizonte": "La simulación se extiende desde el año anio_inicio al año anio_fin",
        "anio":"Año",
        "descargar_resultados_completos":"Completos",
        "descargar_resultados_incompletos":"Sin horarios",
        "tooltip_descargar_con_horarios":"Descargar resultados completos",
        "tooltip_descargar_sin_horarios":"Descargar resultados sin hoja de horarios",
      },
      login: {
        titulo: "Modelo de optimización de diseño de plantas de hidrógeno renovable",
        subtitulo: "Introduce tus credenciales",
        usuario: "Usuario",
        password: "Contraseña",
        boton_entrar: "Entrar"
      },
      mensajes: {
        error: "Error",
        exito: "Enhorabuena",
        simulacion_lanzada_ok: "Simulación lanzada",
        errores_validacion: "Errores de validacion",
        campo_requerido: "Campo requerido",
        "alerta_ya_existe_nombre": "Ya tienes una simulación con ese nombre",
        "alerta_cabeceras":"Las siguientes cabeceras no corresponden con lo esperado:",
        "alerta_cabeceras_no_numericas":"El archivo CSV no tiene un formato válido. Las cabeceras deben contener años numéricos, se han encontrado las siguientes que no lo cumplen:",
        "accion_ya_existe_nombre": "Por favor, elige otro nombre",
        "estas_seguro": "¿Estás seguro?",
        "lanzar_simulacion": "Esto lanzará la simulación con los datos actuales",
        "lanzar_simulacion_ok_titulo":"¡Simulación lanzada!",
        "lanzar_simulacion_ok_subtitulo":"La simulación se ha iniciado correctamente",
        "lanzar_simulacion_error":"Hubo un problema lanzando la simulación",
        "borrar_simulacion": "Esto borrará la simulación.",
        "cambiar_nombre_simulacion": "Esto cambiará el nombre de la simulación.",
        "cambiar_proyecto_simulacion": "Esto cambiará el nombre del proyecto de la simulación.",
        "borrar_simulacion_ok_titulo":"¡Simulación borrada!",
        "borrar_simulacion_ok_subtitulo":"La simulación ha sido borrada correctamente.",
        "borrar_simulacion_error":"Hubo un problema borrando la simulación",
        cargar_caso_base_titulo: "¿Cargar datos de caso base?",
        cargar_caso_base_texto: "Se cargarán en esta pantalla los datos guardados como caso base.",
        cargar_caso_base_aviso: "si ya has importado un caso o modificado datos manualmente, podrían sobrescribirse en la simulación actual.",
        cargar_caso_base_confirmar: "Sí, cargar datos",
        cargar_caso_base_ok_titulo: "Datos cargados",
        cargar_caso_base_ok_texto: "Los datos del caso base se han cargado correctamente.",
        cargar_caso_base_error_titulo: "Error",
        cargar_caso_base_error_texto: "No se pudieron cargar los datos del caso base.",
        obteniendo_precios:"Obteniendo precios...",  
        obteniendo_demanda:"Obteniendo demandas...",
        obteniendo_perfiles:"Obteniendo perfiles...",
        obteniendo_perfil_fv:"Obteniendo perfil fotovoltaico...",
        obteniendo_perfil_eolica:"Obteniendo perfil eolica...",
        obteniendo_curvas:"Obteniendo curvas OPEX/CAPEX...",
        obteniendo_costes:"Obteniendo precios horarios",
        obteniendo_lista:"Obteniendo lista...",
        obteniendo_caso_base: "Obteniendo caso base...",
        obteniendo_resultados: "Obteniendo resultados...",         
        "warning_anios":"Los precios de mercado proporcionados por SimularT llegan hasta 2050. Por favor, revise la senda a partir de este año.",
        obteniendo_simulacion_guardada: "Abriendo simulación ...",
        obteniendo_curvas_elec: "Abriendo curvas electrolizador ...",
        simulacion_guardada_nube: "Simulación guardada en la nube",
        campo_requerido_opexcapex:"Se necesita rellenar el campo para que la simulación no de error",
        aplicando_horizonte:"Cargando horizonte",
          cargando_grafico:"Cargando gráfico",
        excel_demasiadas_filas_titulo:"Número de filas",
        excel_demasiadas_filas_texto:"En el excel importado hay más filas de las permitidas",
      },
      simulaciones: {
        titulo: "Simulaciones",
        manual_usuario: "Manual de usuario",
        boton_manual: "Descargar manual",
        parrafos: [
          "Para aprender a manejar mejor la herramienta, o si queda alguna duda de algún apartado, contamos con un manual técnico y de uso. Se puede obtener pinchando en el botón.",
          "Para poder leer el manual de forma correcta, se aconseja contar con aplicaciones como Visual studio code o MarkText, y extraer el archivo comprimido para poder visualizar correctamente las imágenes.",
        ],
        busqueda: "Busca por ID, nombre y proyecto",

        tabla: {
          nombre: "Nombre",
          proyecto: "Proyecto",
          usuario: "Usuario",
          fecha: "Fecha",
          estado: "Estado",
          barridos: "Sensibilidades",
          acciones: "Acciones",
        },
        boton: {
          nueva: "Crear",
          recargar: "Recargar",
          ver_resultado: "Ver resultado",
          borrar_simulacion: "Borrar",
          configuracion: "Configuracion",
        },
        estados: {
          creada: "Creada",
          guardada: "Guardada",
          en_ejecucion: "En ejecución...",
          ejecutada_ok: "Ejecutada OK",
          ejecutada_nok: "Ejecutada NOK",
          cancelada: "Cancelada",
          borrada: "Borrada",
        }
      },
      simulacion: {
        label_nueva_simulacion: "Nueva simulación",
        label_simulacion_existente: "Simulación",
        boton_lanzar: "Lanzar simulación",
        nombre_defecto: "Título de la simulación",
        boton_descargar_resultados: "Descargar resultados",
        boton_descargar_in: "Descargar fichero IN",
        tab: {
          configuracion: "Diseño",
          planta: "Proyecto",
          hidrogeno:"Hidrógeno",
          datos_anuales:"RFNBO",
          ppas: "PPAs",
          mercado: "Grid",
          economicos:"Datos Económicos",
          resultado: "Resultados",
          electrolizador: "Electrolizador",
          almacenamiento: "Almacenamiento",
          bateria: "Batería",
          fotovoltaica: "Fotovoltaica",
          eolica: "Eólica",
          demanda: "Demanda",
          anual: "Anual",
          mensual: "Mensual",
          diaria: "Diaria",
          configuracion_ppa:"Precios PPA",
          perfiles: "Perfiles PPA Compra",
          planta_electrolisis: "Resto planta H2",
          precios: "Precios",
          peajes:"Peajes",
          curvas: "Curvas CAPEX/OPEX",
          costes:"Coste passthrough",
          config:"Curvas CAPEX/OPEX",
          economicosh:"Otros costes",
          barridos: "Sensibilidades",
          ppa_venta:"Precios PPA Venta RES"
        },

        modulo: {
          electrolizador: {
            titulo: "Electrolizador",
            capex:"CAPEX del electrolizador",
            opex:"OPEX del electrolizador",
            reemplazo:"CAPEX reemplazo stacks (kEUR/MW)",
            pmin: "Potencia mínima (%)",
            prend: "Degradación anual (%)",
            cnag: "Consumo de H2O (l/kgH2)",
            pcag: "Precio del H2O (EUR/m3 H2O)",
            hfun: "hfun", //No existe ya, hay que quitarla
            capexf: "CAPEX fijo electrolizador",
            capexv: "CAPEX variable electrolizador",
            opexf: "OPEX fijo electrolizador",
            opexv: "OPEX variable electrolizador",
            capexr: "CAPEX reemplazo stacks (EUR/MW)",
            vutil: "Vida útil de los stacks (horas)",
            pelfija: "Potencia fija electrolizador (MW)", //Esta entra si es "0" OPT_EL de la pestaña ejecución, por lo que tiene que aparecer ahí
            degrad: "Degradación (%/1.000h de funcionamiento)",
            capexvb: "CAPEX variable BOP (EUR/MW electrolizador)",
            cagmax: "Consumo máximo anual de agua (hm3)",
            datos_operativos: "Datos operativos",
            datos_economicos: "Datos económicos",
          },
           electrolizador_degrad: {
            titulo: "Degradación electrolizador",
            titulo_tabla:"Curva de degradación del electrolizador",
            titulo_curva:"Curva degradación electrolizador",
            anadir_fila: "Añadir fila",
            tramo_electrolizador:"Tramo hora límite (h)",
            degradacion_electrolizador: "Degradación (%/1.000 horas de funcionamiento totales)",
            tipo: "tipo",
            tr1: "tr1",
            tr2: "tr2",
            tr3: "tr3",
            tr4: "tr4",
            tr5: "tr5",
            tr6: "tr6",
          },
          electrolizador_rend: { //Este tenemos que ver cómo introducirlo por pantalla
            titulo: "Rendimiento electrolizador",
            titulo_tabla:"Curva de eficiencia del electrolizador",
            titulo_curva:"Curva eficiencia electrolizador",
            anadir_fila: "Añadir fila",
            uso_electrolizador:"Carga electrolizador (%)",
            eficiencia_electrolizador: "Eficiencia (kWh/kg)",
            tipo: "tipo",
            tr1: "tr1",
            tr2: "tr2",
            tr3: "tr3",
            tr4: "tr4",
            tr5: "tr5",
            tr6: "tr6",
          },
          planta_electrolisis: {
            titulo: "Planta de electrólisis",
            usar_curvas_bop:"Utilizar CAPEX/OPEX general (curvas)",
            sabado_l:"Sábado laborable",
            domingo_l:"Domingos y festivos laborables",
            datos_operativos:"Datos operativos",
            datos_economicos:"Datos económicos",
            cauxmn: "Consumo electricidad BOP en parada (% consumo nominal del electrolizador en plena carga)",
            cauxmx: "Consumo electricidad BOP en operación (% consumo nominal del electrolizador en plena carga)",
            dimducto: "Dimensión del ducto (km)",
            dimconexelec: "Dimensión de la conexión eléctrica (km)",
            dimtube: "Número de tube-tráilers (número)",
            capex:"CAPEX del BOP",
            opex:"OPEX del BOP",
            capexf:"CAPEX fijo del BOP",
            capexv:"CAPEX variable del BOP",
            opexf:"OPEX fijo del BOP",
            opexv:"OPEX variable del BOP",
            capexcel:"CAPEX de la conexión eléctrica de la planta de electrólisis",
            opexcel:"OPEX de la conexión eléctrica de la planta de electrólisis",
            capexfcel:"CAPEX fijo de la conexión eléctrica",
            capexvcel:"CAPEX variable de la conexión eléctrica",
            opexfcel:"OPEX fijo de la conexión eléctrica",
            opexvcel:"OPEX variable de la conexión eléctrica",
            capexduc:"Resultado del cálculo del CAPEX del ducto (kEUR)",
            opexduc:"Resultado del cálculo del OPEX del ducto (kEUR/año)",
            capexele:"Resultado del cálculo del CAPEX de la conexión eléctrica (kEUR)",
            opexele:"Resultado del cálculo del OPEX de la conexión eléctrica (kEUR/año)",
            capextra:"Resultado del cálculo del CAPEX del tube-tráiler (kEUR)",
            opextra:"Resultado del cálculo del OPEX del tube-tráiler (kEUR/año)",
            otros:"Otros",
            h_ini:"Hora de inicio de trabajo",
            h_fin:"Hora de fin de trabajo",
          },
          almacenamiento: {
            titulo: "Almacenamiento",
            pdia: "Pérdidas estáticas (%/día)",
            piny:"Pérdidas por inyección (%/kg H2)",
            pext: "Pérdidas por extracción (%/kg H2)",
            cele: "cele",  //Esta no entra por pantalla pero es el Coeficiente fórmula compresor en kW/(kg/h)
            capex:"CAPEX de almacenamiento",
            opex:"OPEX de almacenamiento",
            capexf: "CAPEX fijo almacenamiento (EUR)",
            capexv: "CAPEX variable almacenamiento (EUR/ton H2)",
            calmfija: "Capacidad fija de almacenamiento (ton H2)", //Esta entra si es "0" OPT_ALM de la pestaña ejecución, por lo que tiene que aparecer ahí
            cmax: "Capacidad máxima de almacenamiento (ton H2)",
          },
          bateria: {
            titulo: "Bateria",
            pmax: "Potencia máxima (MW)",
            capac: "Capacidad (h)",
            rend: "Rendimiento (%)",
            capex:"CAPEX batería",
            capexf: "CAPEX fijo batería",
            capexv: "CAPEX variable batería",
            opex: "OPEX batería",
            opexf: "OPEX fijo batería",
            opexv: "OPEX variable batería",
            degrad: "Degradación anual (%)",
            vutil: "Vida últil batería (años)",
            reempu: "CAPEX reemplazo batería (% respecto al CAPEX)",
            emin: "Energía mínima batería (p.u.)",
            emax: "Energía máxima batería (p.u.)",
            pbatfija: "Potencia fija batería (MW)",
            poiv :"Potencia de acceso de venta batería (MW)"
          },
          fotovoltaica: {
            titulo: "Fotovoltaica",
            hora: "Hora",
            perfil: "Perfil (p.u.)",            
            poi: "POI (MW)",
            capexf: "CAPEX fijo fotovoltaica (EUR)",
            capexv: "CAPEX variable fotovoltaica (EUR/MW)",
            opex: "OPEX fotovoltaica",
            capex:"CAPEX fotovoltaica",
            degrad: "Degradación anual (%)",
            ppvfija: "Potencia fija solar fotovoltaica (MW)", //Esta entra si es "2" OPC_PV de la pestaña ejecución, por lo que tiene que aparecer ahí
            pmax: "Potencia máxima fotovoltaica (MW)", //Esta entra si es "2" OPC_PV de la pestaña ejecución, por lo que tiene que aparecer ahí
            capexcel:"CAPEX de la conexión eléctrica de la planta de FV",
            opexcel:"OPEX de la conexión eléctrica de la planta de FV",
            capexfcel:"CAPEX fijo de la conexión eléctrica",
            capexvcel:"CAPEX variable de la conexión eléctrica",
            opexfcel:"OPEX fijo de la conexión eléctrica",
            opexvcel:"OPEX variable de la conexión eléctrica",
          },
          eolica: {
            titulo: "Eólica",
            hora: "Hora",
            perfil: "Perfil (p.u.)",            
            poi: "POI (MW)",
            capex:"CAPEX eólica",
            capexf: "CAPEX fijo eólica",
            capexv: "CAPEX variable eólica",
            opex: "OPEX eólica",
            opexf: "OPEX fijo eólica",
            opexv: "OPEX variable eólica",
            peolfija: "Potencia fija eólica (MW)", //Esta entra si es "2" OPC_EOL de la pestaña ejecución, por lo que tiene que aparecer ahí
            pmax: "Potencia máxima eólica (MW)",
            capexcel:"CAPEX de la conexión eléctrica de la planta eólica",
            opexcel:"OPEX de la conexión eléctrica de la planta eólica",
            capexfcel:"CAPEX fijo de la conexión eléctrica",
            capexvcel:"CAPEX variable de la conexión eléctrica",
            opexfcel:"OPEX fijo de la conexión eléctrica",
            opexvcel:"OPEX variable de la conexión eléctrica",
          },          
          ppa_configuracion: {
            titulo: "Configuración de los PPAs",
            ppa: "PPA",
            capmax: "Cantidad máxima contratada (MW)",
            pcio: "Precio compra PPA (EUR/MWh)",
            pcio_venta: "Precio venta excedente PPA (EUR/MWh)",
            pcio_compra:"Precio compra PPA (EUR/MWh)",
            "mensaje_check":"Indicar mediante el check si el PPA correspondiente tiene vigencia en dicho año",
            horas: "Horas de utilización (h)",
            cppafija: "Potencia fija PPAs (MW)", //Esta entra si es "0" OPT_PPA de la pestaña ejecución, por lo que tiene que aparecer ahí
            activo1:"Activo1",
            activo2:"Activo2",
            activo3:"Activo3"
          },
          ppa_perfiles: {
            titulo: "Perfiles",
            titulo1:"PPA1",
            titulo2:"PPA2",
            titulo3:"PPA3",
            hora: "Hora",
            ppa1: "PPA1 (p.u.)",
            ppa2: "PPA2 (p.u.)",
            ppa3: "PPA3 (p.u.)"
          },
          ppa_venta:{
            titulo:"Precios PPA Venta RES",
            anio:"Año",
            pcppapv:"Precio fijo venta solar",
            pcppaeol:"Precio fijo venta eólica",
            modo_min_pool:"Utilizar valor mínimo entre pool y valor",
            modo_valor:"Utilizar valor introducido"


          },
          gen: {
            poic: "Potencia de acceso de compra",
            poiv: "Potencia de acceso de venta",
            poiv_pv_venta : "Potencia de acceso de venta FV (MW)",
            poiv_eol_venta : "Potencia de acceso de venta eólica (MW)",
            poiv_res_conjunta: "Potencia de acceso de venta RES conjunta",
            poiv_res_conjunta_si: "Con potencia de acceso de venta RES conjunta",
            poiv_res_conjunta_no: "Sin potencia de acceso de venta RES conjunta",
            poiv_res: "Potencia de acceso de venta RES (MW)",
            "opc_poic": "Potencia de acceso de compra",
            "opc_poic_opt": "Optimizar potencia de acceso de compra",
            "opc_poic_fix": "Potencia de acceso de compra fija",
            "poicmin": "Potencia de acceso de compra mínima (MW)",
            "poicmax": "Potencia de acceso de compra máxima (MW)",
            "poicfij": "Potencia de acceso de compra fija (MW)",
            "pcpoic": "Precio potencia de acceso de compra (EUR/MW)"
      
          },

          demanda: {
            titulo: "Demanda",
            subtitulo:"Hidrógeno verde",
            OPC_LCOHLC_activado:"Demanda de low carbon",
            OPC_LCOHLC_desactivado:"Valorizar subproducto de low carbon como ingreso extraordinario",
            H2VOb:"Precio inicial demanda obligatorio H2 verde (EUR/kgH2)",
            H2VOp:"Precio inicial demanda opcional H2 verde (EUR/kgH2)",
            H2LOb:"Precio inicial demanda obligatorio H2 low carbon (EUR/kgH2)",
            H2LOp:"Precio inicial demanda opcional H2 low carbon (EUR/kgH2)",
            aplicar_inflacion:"Aplicar inflacion",
            alerta:"La demanda de hidrógeno <i>low-carbon</i> se encuentra deshabilitada al tratarse de una simulación <i>off-grid</i>.",
            tabla: {
              id: "Fecha",
              dH2Ob: "Demanda obligatoria H2 verde (tonH2)",
              pcH2Ob: "Precio de demanda obligatoria H2 verde (EUR/kgH2)",
              dH2Op: "Demanda opcional H2 verde (tonH2)",
              pcH2Op: "Precio de demanda opcional H2 verde (EUR/kgH2)",

            },
            
          },
          demanda_lc: {
            titulo: "Demanda",
            subtitulo:"Hidrógeno low carbon",
            tabla: {
              id: "Fecha",
              dH2Ob: "Demanda obligatoria H2 low carbon (tonH2)",
              pcH2Ob: "Precio de demanda obligatoria H2 low carbon (EUR/kgH2)",
              dH2Op: "Demanda opcional H2 low carbon (tonH2)",
              pcH2Op: "Precio de demanda opcional H2 low carbon (EUR/kgH2)",
              dmH2Oex:"Demanda máxima H2 low carbon excedente (ton H2)",
              pcH2Oex:"Precio de demanda H2 low carbon excedente",
            },
            
          },
          datos_anuales:{
            titulo: "Datos anuales",
            tabla:{
              anio:"Año",
              emisiones:"Emisiones H2 (gCO2/MJ)",
              GHG:"GHG (gCO2/MJ)",
              RES:"RES (%)",
              precio_limite:"Precio límite compra a mercado (EUR/MWh)",
              correlacion:"Correlación",
              precio_garantia:"Precio garantías de origen eléctricas (EUR/MWh)",
              opcion_mensual_true:"Mensual",
              opcion_mensual_false:"Horaria",
              "tabla_limite": {
                "titulo":"Valores límite",
                "anio": "Año",
                "lim_emisiones_h2": "Límite Emisiones H2 (gCO2/MJ)",
                "lim_res": "Límite RES (%)",
                "precio_limite": "Precio límite compra a mercado (EUR/MWh)"
              },
              "tabla_previstos": {
                "titulo":"Valores previstos",
                "anio": "Año",
                "ghg": "GHG (gCO2/MJ)",
                "res": "RES (%)",
                "correlacion": "Correlación"
              }
            }
           
          },
          datos_economicos_hidrog:{
            titulo: "Otros costes",
            tabla:{
              anio:"Año",
              impcomc:"Impuesto de comercialización de compra (%)",
              ccomv: "Impuesto de venta de energía (%)",
              pgdoe: "GDOs eléctricas (EUR/MWh)",
            }
          },
          precios: {
            titulo: "Precios (EUR/MWh)",
            hora: "Hora",
          },
          peajes:{
            titulo: "Peajes y cargos",
            selec_pais:"País",
            selec_tarif:"Tarifa",
            termino_p:"Término de peajes ",
            termino_pot_p:"Término de peaje de potencia ",
            termino_c:"Término de cargos ",
            termino_pot_c:"Término de cargos de potencia ",
            tipo:"Tipo",
            energia:"Energía (EUR/kWh)",
            potencia:"Potencia (EUR/kW año)",
            country_esp:"España",
            country_pt:"Portugal",
            grupo_t:"Grupo tarifario",
            switch_1:"Utilizar cargos",
            switch_2:"Usar perfil horario passthrough",
            inflacion_inicial:"Inflación inicial (%)",
            subida_anual:"Subida anual (% sobre la inicial)",
            valor_inicial_passthrough:"Valor horario passthrough",

          },
          datos_economicos:{
                titulo:"Reparto CAPEX",
                anio_inicio_capex:"Año inicio CAPEX",
                reparto_capex_h2:"% CAPEX planta H2",
                reparto_capex_fv:"% CAPEX planta solar FV",
                reparto_capex_eol:"% CAPEX planta eólica",
                reparto_CAPEX:"Reparto CAPEX",
                error:"La suma debe ser igual a 100%",
                anio:"Año",
                porcentaje_CAPEX:"% CAPEX",
                anio_inicio:"Año",
                titulo_tabla:"Subvenciones",
                columna_subvencion:"Subvenciones kEUR",
                columna_subv_RFNBO:"Subvenciones €/kg H2 RFNBO producido"
            },

          curvas_CAPEXOPEX: { 
            capex_opex_curvas: "Utilizar CAPEX/OPEX general (curvas)",
            capex_opex_especifico: "Utilizar valores CAPEX/OPEX específicos",
            opex_anual:"Utilizar senda anual OPEX",
            switch_curvas:"Usar curvas",
            switch_especificos:"Usar valores específicos",
            variable:"Variable ",
            fijo:"Fijo ",
            variable_units:"Variable (kEUR/MW año)",
            fijo_units:"Fijo (kEUR año)",
            opex_anual_title:"Opex anual",
            precio_transferencia_interno:"Precio de transferencia interno (EUR/MWh)",
          },
          ejecucion: {
            titulo: "Diseño de la simulación",  
            anio_inicio: "Año COD",
            anio_inicio_solar: "Año COD solar fotovoltaica",
            anio_inicio_eolica: "Año COD eólica",
            anio_fin: "Año de fin",
            anio_ejec:"Años de explotación",
            mes_inic:"Mes de inicio",
            mes_inic_solar:"Mes de inicio de la solar PV",
            mes_inic_eolica:"Mes de inicio de la eolica",
            OPC_EJEC: "Objetivo", //Desplegable, ya lo tienes escrito 
            "OPC_ELE": "Opciones del electrolizador",
            OPC_BAT: "Opciones de la batería",
            OPC_VBAT: "Permitir venta batería a mercado",
            "OPC_ALM": "Opciones del almacenamiento de hidrógeno",              
            OPC_MIP:  "OPC_MIP", //No entra por pantalla
            OPC_MCDO: "Opciones de mercado",  //Desplegable, ya lo tienes escrito           
            OPC_PV:   "Opciones fotovoltaica", //Desplegable, ya lo tienes escrito
            OPC_EOL:  "Opciones eólica", //Desplegable, ya lo tienes escrito
            OPCDEM_A:  "Modo demanda anual", //Tiene que ser un click que ponga a "1" si se activa, "0" si se desactiva
            OPCDEM_M:  "Modo demanda mensual", //Tiene que ser un click que ponga a "1" si se activa, "0" si se desactiva
            OPCDEM_D:  "Modo demanda diaria", //Tiene que ser un click que ponga a "1" si se activa, "0" si se desactiva
            TASA_DCTO:  "Tasa de descuento (%)",
            subtitulo_horario:"Horario producción planta H2",
            INFL_COD:"Año base de inflación",
            TASA_INFL:  "Inflación anual (%)",
            OPC_AMORT: "Considerar amortización para LCOH",
            LIMIT_MCDO:  "Precio límite compra a mercado (EUR/MWh)",
            OPC_PPA: "Opciones PPAs compra", //Tiene que ser un click que ponga a "1" si se activa, "0" si se desactiva
            OPC_EL: "Opciones del electrolizador", //Tiene que ser un click que ponga a "1" si se activa, "0" si se desactiva
            OPT_ALM: "Optimizar almacenamiento", //Tiene que ser un click que ponga a "1" si se activa, "0" si se desactiva    
            IMPTO_SOC:"Impuesto de sociedades",
            FV_FIJA:"Utilizar PPAs venta solar",
            EO_FIJA:"Utilizar PPAs venta eólica",
            pcppapv: "Precio fijo venta solar",
            pcppaeol: "Precio fijo venta eólica",
            ANIO_PPA_INI:"Año inicio PPA",
            ANIO_PPA_FIN:"Año fin PPA",
            opciones: {
              
              meses: {
                enero: 'Enero',
                febrero: 'Febrero',
                marzo: 'Marzo',
                abril: 'Abril',
                mayo: 'Mayo',
                junio: 'Junio',
                julio: 'Julio',
                agosto: 'Agosto',
                septiembre: 'Septiembre',
                octubre: 'Octubre',
                noviembre: 'Noviembre',
                diciembre: 'Diciembre',
              },
              lcoh_min :"Minimizar LCOH",
              npv_max :"Maximizar VAN",

              no_limit :"Compra sin límite de precio a mercado",
              price_limit:"Compra para electrolizador con límite de precio",
              compra_mercado:"Compra a mercado",
              buy_aux:"Compra a mercado sólo para BOP",
              off_grid:"Sin conexión a red (proyecto off-grid)",

              
              no_bat :"Sin batería",
              opt_bat:"Optimizar batería",
              bat_fix_cap:"Batería fija",   



              no_pv :"Sin planta solar fotovoltaica",
              opt_pv:"Optimizar planta solar fotovoltaica",
              pv_fix_cap:"Planta solar fotovoltaica fija",     

              no_eol :"Sin planta eólica",
              opt_eol:"Optimizar planta eólica",
              eol_fix_cap:"Planta eólica fija",  

              no_alm: "Sin almacenamiento",
              opt_alm: "Optimizar el almacenamiento",
              alm_fix: "Almacenamiento fijo",

              opt_elec: "Optimizar el electrolizador",
              elec_fix: "Electrolizador fijo",

              no_ppas: "Sin PPAs",
              opt_ppas: "Optimizar PPAs",
              ppas_fix: "PPAs fijo",
              OPC_AMORT_si:"Si",
              OPC_AMORT_no:"No",


            },
            tabla: {
              ppa:"PPA",
              cppafija: "Potencia fija PPAs (MW)" //Está definido antes ya
            },
            switch:{
              ducto:"¿Utilizar ducto?",
              conexion:"Utilizar conexión eléctrica",
              tt:"¿Utilizar tube-trailers?",
              span:"La conexión eléctrica no está disponible en modo Off-grid",

            }

          },
          resultado: {
            titulo: "Resultado",
            titulo_diseno: "Diseño",
            titulo_resumen:"Resumen",
            titulo_economico:"Resultados económicos",
            titulo_variables: "Variables",
            titulo_temporalidad:"Análisis temporal",
            parametro: "Parametro",
            codigo_colores:"Código de colores:",
            variable:"Variable",
            valor: "Valor",
            unidad:"Unidad",
            horizonte_completo:"Horizonte completo",
            cargar_grafico:"Cargar gráfico de producción de H2",

            general:"General",
            energia:"Energía",
            planta_electrolisis:"Planta de electrólisis",
            electrolizador:"Electrolizador",
            almacenamiento_hidrogeno:"Almacenamiento de hidrógeno",
            baterias:"Baterías",
            demanda:"Demanda",
            param_econ:"Parámetros económicos",


            PI_EL: "Potencia electrolizador (MW)",
            CAP_ALM: "Capacidad almacenamiento (ton H2)",
            PC_PPA1: "Potencia contratada PPA1 (MW)",
            PC_PPA2: "Potencia contratada PPA2 (MW)",
            PC_PPA3: "Potencia contratada PPA3 (MW)",
            PI_BAT: "Potencia baterías (MW)",
            PI_PV: "Potencia planta solar fotovoltaica (MW)",
            PI_EOL: "Potencia planta eólica (MW)",
            LCOH: "LCOH (EUR/kgH2)",
            HFUN: "Horas de funcionamiento del electrolizador (h)",
            HEQ:"Horas equivalentes electrolizador (h)",

            "resumen": {
              "intervalo": "Horizonte de operación",
              "mes_inicio":"Mes de inicio",
              reparto_capex:"Reparto de CAPEX",
              "total_anios": "Total de años",
              "funcion_objetivo": "Función objetivo",
              "modo_de_aprovisionamiento": "Modo de aprovisionamiento",
              "opciones_del_electrolizador": "Opciones del electrolizador",
              "opciones_del_almacenamiento": "Opciones del almacenamiento",
              "opciones_bateria": "Opciones de la batería",
              "opciones_venta_bateria": "Permitir venta batería a mercado",
              "opciones_solar_fotovoltaica": "Opciones solar fotovoltaica",
              "opciones_eolica": "Opciones eólica",
              "opciones_ppa": "Opciones PPA",
              "opciones_poic":"Opciones de acceso de compra",
              "opciones_demanda": "Opciones de demanda",
              "lcoh": "LCOH (pre-tax)",
              "npv": "NPV (pre-tax)",
              "tir": "TIR (pre-tax)",
              "poic_c":"Potencia de acceso",
              "energia_comprada_a_mercado": "Energía comprada a mercado",
              "potencia_contratada_ppa1": "Potencia contratada PPA1",
              "energia_consumida_ppa1": "Energía consumida PPA1",
              "energia_vendida_ppa1": "Energía vendida PPA1",
              "potencia_contratada_ppa2": "Potencia contratada PPA2",
              "energia_consumida_ppa2": "Energía consumida PPA2",
              "energia_vendida_ppa2": "Energía vendida PPA2",
              "potencia_contratada_ppa3": "Potencia contratada PPA3",
              "energia_consumida_ppa3": "Energía consumida PPA3",
              "energia_vendida_ppa3": "Energía vendida PPA3",
              "potencia_instalada_planta_solar_fotovoltaica": "Potencia instalada planta solar fotovoltaica",
              "energia_producida_planta_solar_fotovoltaica": "Energía producida planta solar fotovoltaica",
              "energia_consumida_planta_solar_fotovoltaica": "Energía consumida planta solar fotovoltaica",
              "vertidos_fv":"Vertidos planta solar fotovoltaica",
              "energia_vendida_pv":"Ventas a mercado de solar",
              "potencia_instalada_planta_eolica": "Potencia instalada planta eólica",
              "energia_producida_planta_eolica": "Energía producida planta eólica",
              "energia_consumida_planta_eolica": "Energía consumida planta eólica",
              "vertidos_eolica":"Vertidos planta eólica",
              "energia_vendida_eol":"Ventas a mercado de eólica",
              "potencia_nominal_electrolizador": "Potencia nominal electrolizador",
              "potencia_minima_electrolizador": "Potencia mínima electrolizador",
              "horas_de_funcionamiento_electrolizador": "Horas de funcionamiento electrolizador",
              "horas_equivalentes_electrolizador":"Horas equivalentes electrolizador",
              "degradacion_anual_electrolizador": "Degradación anual electrolizador",
              "sustitucion_stacks_electrolizador": "Sustitución de stacks electrolizador",
              "consumo_de_agua_electrolizador": "Consumo de agua electrolizador",
              "consumo_energia_electrolizador": "Consumo de energía electrolizador",
              "produccion_RFNBO":"Producción RFNBO",
              "produccion_Low_carbon":"Producción Low Carbon",
              "consumo_energia_bop": "Consumo de energía BOP",
              "capacidad_de_almacenamiento_de_hidrogeno": "Capacidad de almacenamiento de hidrógeno",
              "perdidas_estaticas_almacenamiento_hidrogeno": "Pérdidas estáticas almacenamiento hidrógeno",
              "perdidas_por_inyeccion_almacenamiento_hidrogeno": "Pérdidas por inyección almacenamiento hidrógeno",
              "perdidas_por_extraccion_almacenamiento_hidrogeno": "Pérdidas por extracción almacenamiento hidrógeno",
              "potencia_baterias": "Potencia de baterías",
              "duracion_baterias": "Duración de baterías",
              "capacidad_de_almacenamiento_baterias": "Capacidad de almacenamiento de baterías",
              "rendimiento_baterias": "Rendimiento de baterías",
              "degradacion_anual_baterias": "Degradación anual de baterías",
              "vida_util_baterias": "Vida útil de baterías",
              "consumo_energia_baterias": "Energía entrante a la batería",
              "produccion_energia_baterias": "Energía de batería a ELY",
              "energia_vendida_baterias":"Energía de batería a mercado",
              "demanda_obligatoria": "Demanda H2 RFNBO obligatoria",
              "precio_demanda_obligatoria": "Precio demanda H2 RFNBO obligatoria",
              "demanda_obligatoria_lc": "Demanda H2 low carbon obligatoria",
              "precio_demanda_obligatoria_lc": "Precio demanda H2 no RFNBO obligatoria",
              "demanda_opcional": "Demanda H2 RFNBO opcional",
              "precio_demanda_opcional": "Precio demanda H2 RFNBO opcional",
              "demanda_opcional_lc": "Demanda H2 low carbon opcional",
              "precio_demanda_opcional_lc": "Precio demanda H2 low opcional",
              "demanda_H2_no_suministrada":"Demanda H2 no suministrada",
              "demanda_H2_no_atendida_RFNBO":"Demanda H2 RFNBO no atendida",
              "demanda_H2_no_atendida_LC":"Demanda H2 low carbon no atendida",
              "capex_electrolizador": "CAPEX electrolizador",
              "capex_reemplazo_stacks_electrolizador": "CAPEX reemplazo stacks electrolizador",
              "capex_almacenamiento": "CAPEX almacenamiento",
              "capex_poic":"CAPEX potencia de acceso",
              "capex_baterias": "CAPEX baterías",
              "capex_reemplazo_stacks_baterias": "CAPEX reemplazo stacks baterías",
              "capex_planta_solar_fotovoltaica": "CAPEX planta solar fotovoltaica",
              "capex_planta_eolica": "CAPEX planta eólica",
              "capex_subv":"CAPEX subvenciones",
              "capex_subv_uni":"CAPEX subvenciones unitarias",
              "capex_total": "CAPEX total",
              "coste_ppa1": "Coste PPA1",
              "coste_ppa2": "Coste PPA2",
              "coste_ppa3": "Coste PPA3",
              "coste_ppa1_p":"Coste passthrough PPA1",
              "coste_ppa2_p":"Coste passthrough PPA2",
              "coste_ppa3_p":"Coste passthrough PPA3",
              "coste_ppa1_i":"Coste impuesto eléctrico PPA1",
              "coste_ppa2_i":"Coste impuesto eléctrico PPA2",
              "coste_ppa3_i":"Coste impuesto eléctrico PPA3",
              "coste_energia_a_mercado": "Coste energía a mercado",
              "coste_energia_a_mercado_P": "Coste passthrough de mercado",
              "coste_energia_a_mercado_I": "Coste impuesto eléctrico de mercado",
              "coste_impuesto_PV":"Coste Impuesto eléctrico PV",
              "coste_impuesto_EOL":"Coste Impuesto eléctrico Wind",
              "coste_tarifas": "Coste tarifas",
              "coste_tarifas_e":"Coste peajes y cargos energía",
              "coste_tarifas_p":"Coste peajes y cargos potencia",
              "coste_gdo":"Coste GDOs eléctricas",
              "coste_agua": "Coste agua",
              "coste_operacion_y_mantenimiento_total": "Coste operación y mantenimiento total",
              "coste_total": "Coste total",
              "ingreso_demanda_obligatoria": "Ingreso demanda obligatoria",
              "ingreso_demanda_obligatoria_verde": "Ingreso demanda obligatoria RFNBO",
              "ingreso_demanda_obligatoria_lowcarbon": "Ingreso demanda obligatoria low carbon",

              "ingreso_demanda_opcional": "Ingreso demanda opcional",
              "ingreso_demanda_opcional_verde": "Ingreso demanda opcional RFNBO",
              "ingreso_demanda_opcional_lowcarbon": "Ingreso demanda opcional low carbon",
              "valor_no_RFNBO": "Valorización low carbon",

              "ingreso_planta_solar_fotovoltaica": "Ingreso planta solar fotovoltaica",
              "ingreso_planta_eolica": "Ingreso planta eólica",
              "ingreso_ppa1": "Ingreso PPA1",
              "ingreso_ppa2": "Ingreso PPA2",
              "ingreso_ppa3": "Ingreso PPA3",
              "ingreso_bateria":"Ingreso Batería",
              "inflacion_anual": "Inflación anual",
              "tasa_de_descuento": "Tasa de descuento",
              "consumo_electricidad_bop":"Consumo energía BOP",
              "consumo_electricidad_compresor":"Consumo energía compresor",
              "capex_bop":"CAPEX BOP",
              "opex_total":"OPEX total",
              "capex_ducto":"CAPEX ducto",
              "capex_con":"CAPEX conexión eléctrica",
              "capex_tube":"CAPEX tube-tráilers"
            },
            "flujos-caja": {
              "titulo": "Resumen CAPEX/OPEX",
              "tab": "Resultados económicos",
              "titulo-tabla": "Tabla resumen",
              "tabla_cashflow": "Tabla cashflow",
              "tabla_anio": "Año",
              "tabla_capex": "CAPEX",
              "tabla_capex-revamping": "CAPEX Revamping",
              "tabla_subvencion": "Subvención",
              "tabla_subvencion_uni": "Subvenciones unitarias",
              "tabla_capex-res": "CAPEX RES",
              "tabla_opex-electrico": "OPEX eléctrico",
              "tabla_opex-h2": "OPEX planta H2",
              "tabla_opex-res": "OPEX RES",
              "tabla_ingresos-electrico": "Ingresos eléctricos",
              "tabla_otros": "Otros ingresos",
              "tabla_ingresos-h2-verde": "Ingresos H2 verde",
              "tabla_ingresos-h2-lowcarbon": "Ingresos H2 low-carbon",
              "tabla_cf-total": "CF operativo pre-tax",
              "grafica_cascada":"Gráfica cascada",
              "lcoe_pv":"LCOE solar PV",
              "lcoe_eolica":"LCOE eólica",
              "graficas": {
                "capex": "CAPEX",
                "capexRevamping": "CAPEX Revamping",
                "subvencion": "Subvención",
                "subvencion_uni":"Subvenciones unitarias",
                "capexRES": "CAPEX RES",
                "opexElec": "OPEX eléctrico",
                "opexH2": "OPEX planta H2",
                "opexRES": "OPEX RES",
                "ingresosElec": "Ingresos eléctricos",
                "otrosIngresos":"Otros ingresos",
                "ingresosH2verde": "Ingresos H2 verde",
                "ingresosH2lowcarbon": "Ingresos H2 low-carbon",
                "ingresosVallowcarbon": "Ingresos valoración low-carbon",
                "cfTotal": "CF operativo pre-tax",
                "LCOH":"LCOH",
                "amortizacion":"Amortización",
                "aumento":"Aumento",
                "disminucion":"Disminución",
                "total":"Total",
              }
          },
          "periodo-tarifario":{
            tab:"Periodos tarifarios",
            titulo:"Potencia contratada anual por periodos tarifarios",
            anio:"Año",
            p1_mw:"Periodo 1 (MW)",
            p2_mw:"Periodo 2 (MW)",
            p3_mw:"Periodo 3 (MW)",
            p4_mw:"Periodo 4 (MW)",
            p5_mw:"Periodo 5 (MW)",
            p6_mw:"Periodo 6 (MW)",

            p1:"Periodo 1 (h)",
            p2:"Periodo 2 (h)",
            p3:"Periodo 3 (h)",
            p4:"Periodo 4 (h)",
            p5:"Periodo 5 (h)",
            p6:"Periodo 6 (h)",
            titulo_utilizacion:"Utilización de periodos tarifarios"
          },
          "temporal": {
          "botones": {
            "aplicar": "Aplicar"
          },
          "filtros": {
            "tipo_periodo": "Tipo de Periodo",
            "seleccionar_periodos": "Seleccionar Periodos",
            "seleccionar_mes": "Seleccionar Mes",
            "seleccionar_semana": "Seleccionar Semana",
            "seleccionar_dias_semana": "Seleccionar Días de la Semana",
            "seleccionar_anios": "Seleccionar Años"
          },
          "periodos": {
            "mensual": "Mensual",
            "trimestral": "Trimestral",
            "anual": "Anual",
            "semanal": "Semanal"
          },
          "mes": {
            "enero": "Enero",
            "febrero": "Febrero",
            "marzo": "Marzo",
            "abril": "Abril",
            "mayo": "Mayo",
            "junio": "Junio",
            "julio": "Julio",
            "agosto": "Agosto",
            "septiembre": "Septiembre",
            "octubre": "Octubre",
            "noviembre": "Noviembre",
            "diciembre": "Diciembre"
          },
          "trimestre": {
            "t1": "T1",
            "t2": "T2",
            "t3": "T3",
            "t4": "T4"
          },
          "semana": {
            "1": "Semana 1",
            "2": "Semana 2",
            "3": "Semana 3",
            "4": "Semana 4"
          },
          "dia_semana": {
            "lunes": "Lunes",
            "martes": "Martes",
            "miercoles": "Miércoles",
            "jueves": "Jueves",
            "viernes": "Viernes",
            "sabado": "Sábado",
            "domingo": "Domingo"
          },
          "unidades": {
            "mwh": "MWh",
            "ton_h2": "ton H2"
          },
          "graficas": {
            "h2_origen": {
              "titulo": "Hr. H2 Production: RFNBO & Low Carbon"
            }
          },
          "origen": {
            "grid_verde": "GRID no RFNBO",
            "grid_rfnbo": "GRID RFNBO",
            "grid":"GRID",
            "ppa_verde_rfnbo": "PPA",
            "res_verde_rfnbo": "RES",
            "total_verde_rfnbo":"Total RFNBO + no RFNBO hr",
            "total_rfnbo":"RFNBO",
            "total_no_rfnbo":"No RFNBO"
          },
          "series": {
            "total_h2": "Total H2",
            "h2_verde": "H2 Verde",
            "h2_low_carbon": "H2 Low Carbon"
          },
          "mensajes": {
            "aplicando_filtros": "Aplicando filtros...",
            "cargando": "Cargando...",
            "cargando_grafico": "Cargando gráfico...",
            "preparando_datos": "Preparando datos..."
          }
        }

               

},


        },
        barridos:{
          titulo:"Sensibilidades ID",
          boton_descargar_in:"Descargar IN",
          boton_lanzar:"Lanzar",
          boton_anadir:"Añadir",
          boton_descargar:"Descarga excel",
          boton_cerrar:"Cerrar",
          resumen_titulo:"Resumen de simulación",
          simulacion:"Simulación",
          titulo_grafica:"Comparación TIR y LCOH",
          eolica:"Eólica",
          solar:"Solar",
          electrolizador:"Electrolizador",
          potencia_eolica:"Potencia eólica",
          potencia_solar:"Potencia solar",
          potencia_elec:"Potencia electrolizador",
          valor_enter:"Añadir valor y pulsa Enter",
          inicial:"Inicial",
          valores_iniciales:"Valores iniciales",
          simulacion_original:"Simulación Original",




        }

      },
      pestana_configuracion_general:{
        tab_curvas:"Curvas",
        tab_coste:"Coste passthrough",
        tab_electrolizador:"Electrolizador",
        simulacion:"Simulación Base"
      },
      config_costes:{
        titulo:"Coste passthrough",
        col_horas:"Horas",
        col_valores:"Coste passthrough (EUR/MWh)",
        descarga:"coste_passthrough",
      }, 
      pestana_configuracion:{
            guardar:"Guardar",
            anadir_fila:"Añadir fila",
            electrolizador:"Electrolizador",
            planta_fv:"Planta solar fotovoltaica",
            planta_eolica:"Planta eólica",
            bateria:"Batería",
            almacenamiento_hidrogeno:"Almacenamiento de hidrógeno",
            ducto:"Ducto",
            conexion_electrica:"Conexión eléctrica",
            tube_trailer:"Tube-tráiler",
            capex_opex:"CAPEX y OPEX por unidad",
            capex:"CAPEX (kEUR)",
            opex:"OPEX (kEUR/año)",
            nombres_curvas: {
              "Electrolizador": "Electrolizador",
              "BOP":"BOP",
              "Planta solar fotovoltaica": "Planta solar fotovoltaica",
              "Planta eólica": "Planta eólica",
              "Batería": "Batería",
              "Almacenamiento de hidrógeno": "Almacenamiento de hidrógeno",
              "Ducto": "Ducto",
              "Conexión eléctrica": "Conexión eléctrica",
              "Tube-tráiler": "Tube-tráiler",
              
            }
          


          },
          diagrama: {
            centro_operativo:"Centro operativo H₂",
            modulos:"Estado de módulos activos",
            celdas:"Celdas",
            online:"online",
            nodos: {
              resultados:"Resultados generales",
              indicador:"Indicador",
              valor:"Valor",
              demanda_no_suministrada:"Demanda H2 no suministrada",
              electricidad: "Suministro de electricidad",
              hidrogeno: "Producción, almacenamiento y distribución de H₂",
              demanda: "Demanda",
              compra:"Compra",
              venta:"Venta",
              agua: "Suministro de agua",
              conexion_electrica: "Conexión eléctrica",
              electrolizador: "Electrolizador",
              eolica: "Eólica",
              solar: "Fotovoltaica",
              compresor: "Compresor",
              almacen: "Almacenamiento de H₂",
              camion: "Tube-trailers",
              tubo: "Gasoducto de H₂",
              consumo: "Demanda / Industria",
              grid: "Red eléctrica",
              ppas: "Contratos PPA",
              bess: "Baterías (BESS)",
              demanda1: "🟢 Demanda de H₂ RFNBO",
              demanda2: "🟠 Demanda de H₂ no RFNBO",
              poi_c:"📍 Potencia de acceso"
            },            
            conexiones: {
              agua: "Agua",
              energia_eolica: "Energía eólica",
              energia_solar: "Energía solar",
              h2_generado: "H₂ generado",
              h2_comprimido: "H₂ comprimido",
              distribucion: "Distribución",
              suministro: "Suministro",
              apoyo_electrico: "Apoyo eléctrico",
              contrato_ppas: "Contrato PPAs",
              contrato_bateria: "Energía batería"
            }
          }
          

    },    

    
      "en": {   
        "comun": {
          "boton_exportar": "Export",
          "boton_importar": "Import",
          cargar_datos:"Load data",
          guardar_datos:"Save",
          guardar_caso_base:"Save base case",
          boton_ok: "OK",
          boton_cancelar: "Cancel",
          "si":"Yes",
          "no":"No",
          "aplicar": "Apply",
          "horizonte":"Horizon",
          "texto_horizonte": "The simulation extends from year anio_inicio to year anio_fin",
          "anio":"Year",
          "descargar_resultados_completos": "Complete",
          "descargar_resultados_incompletos": "Without schedules",
          "tooltip_descargar_con_horarios": "Download complete results",
          "tooltip_descargar_sin_horarios": "Download results without schedule sheet"
        },
        "login": {
          "titulo": "Design optimization model for renewable hydrogen plants",
          "subtitulo": "Enter your credentials",
          "usuario": "User",
          "password": "Password",
          "boton_entrar": "Log In"
        },
        "mensajes": {
          "error": "Error",
          "exito": "Success",
          "simulacion_lanzada_ok": "Simulation launched",
          "errores_validacion": "Validation errors",
          "campo_requerido": "Field required",
          "alerta_ya_existe_nombre": "You already have a simulation with that name",
          "accion_ya_existe_nombre": "Please, Choose another name",
          "alerta_cabeceras":"The following headers do not match the expected format:",
          "alerta_cabeceras_no_numericas":"The CSV file does not have a valid format. The header must contain numeric years.",
          "estas_seguro": "You're sure?",
          "lanzar_simulacion": "This will launch the simulation with the current data",
          "lanzar_simulacion_ok_titulo":"Simulation launched!",
          "lanzar_simulacion_ok_subtitulo":"The simulation has started successfully.",
          "lanzar_simulacion_error":"There was a problem launching the simulation.",
          "borrar_simulacion": "This will delete the simulation",
          "cambiar_nombre_simulacion": "This will change the name of the simulation.",
          "cambiar_proyecto_simulacion": "This will change the project name of the simulation.",
          "borrar_simulacion_ok_titulo":"Simulation deleted!",
          "borrar_simulacion_ok_subtitulo":"The simulation has been deleted successfully.",
          "borrar_simulacion_error":"There was a problem deleting the simulation.",
          cargar_caso_base_titulo: "Load base case data?",
          cargar_caso_base_texto: "The data saved as the base case will be loaded into this screen.",
          cargar_caso_base_aviso: "if you have already imported a case or manually modified data, it may be overwritten in the current simulation.",
          cargar_caso_base_confirmar: "Yes, load data",
          cargar_caso_base_ok_titulo: "Data loaded",
          cargar_caso_base_ok_texto: "The base case data has been loaded successfully.",
          cargar_caso_base_error_titulo: "Error",
          cargar_caso_base_error_texto: "The base case data could not be loaded.",
          obteniendo_precios: "Fetching prices...",
          obteniendo_demanda: "Fetching demands...",
          obteniendo_perfiles: "Fetching profiles...",
          obteniendo_perfil_fv: "Fetching photovoltaic profile...",
          obteniendo_perfil_eolica: "Fetching wind profile...",
          obteniendo_curvas: "Fetching OPEX/CAPEX curves...",
          obteniendo_costes:"Fetching hourly costs...",
          obteniendo_lista: "Fetching list...",
          obteniendo_caso_base: "Fetching base case...",
          obteniendo_resultados: "Fetching results...",
          "warning_anios":"The market prices provided by SimularT are available up to the year 2050. Please review the trajectory beyond that year.",
          obteniendo_simulacion_guardada: "Opening simulation...",
          simulacion_guardada_nube: "Simulation saved in the cloud",
          campo_requerido_opexcapex: "This field must be filled in to prevent the simulation from failing.",
          aplicando_horizonte:"Loading horizon",
          cargando_grafico:"Loading graph",
          excel_demasiadas_filas_titulo:"Number of rows",
        excel_demasiadas_filas_texto:"The imported Excel file contains more rows than allowed",
        },
        "simulaciones": {
          "titulo": "Simulations",
          "manual_usuario": "User Manual",
          "boton_manual": "Download Manual",
          "busqueda": "Search by ID, name, and project",
          "parrafos": [
            "To better understand how to use the tool, or if you have any questions about a specific section, we provide a technical and user manual. You can obtain it by clicking the button.",
            "To properly read the manual, it is recommended to use applications such as Visual Studio Code or MarkText and extract the compressed file to correctly display the images.",
          ],
          "tabla": {
            "nombre": "Name",
            "proyecto": "Project",
            "usuario": "User",
            "fecha": "Date",
            "estado": "Status",
            "barridos": "Sensitivities",
            "acciones": "Actions",
          },
          "boton": {
            "nueva": "Create",
            "recargar": "Reload",
            "ver_resultado": "View Result",
            "borrar_simulacion": "Delete",
            "configuracion": "Configuration",
          },
          "estados": {
            "creada": "Created",
            "guardada": "Saved",
            "en_ejecucion": "Running...",
            "ejecutada_ok": "Executed OK",
            "ejecutada_nok": "Executed NOK",
            "cancelada": "Cancelled",
            "borrada": "Deleted",
          }
        },
        "simulacion": {
          "label_nueva_simulacion": "New Simulation",
          "label_simulacion_existente": "Simulation",
          "boton_lanzar": "Launch simulation",
          "nombre_defecto": "Simulation's title",
          "boton_descargar_resultados": "Download Results",
          "boton_descargar_in": "Download IN file",
          "tab": {
            "configuracion": "Design",
            "planta": "Plant",
            "hidrogeno":"Hydrogen",
            "datos_anuales":"RFNBO",
            "ppas": "PPAs",
            "mercado": "Grid",
            "economicos":"Economic data",
            "resultado": "Result",
            "electrolizador": "Electrolyzer",
            "planta_electrolisis": "Rest of plant H2",
            "almacenamiento": "Storage",
            "bateria": "Battery",
            "fotovoltaica": "Photovoltaic",
            "eolica": "Wind",
            "demanda": "Demand",
            "anual": "Annual",
            "mensual": "Monthly",
            "diaria": "Daily",
            "configuracion_ppa":"PPA prices",
            "perfiles": "PPA profiles purchase",
            "precios":"Prices",
            "peajes":"Tolls",
            "curvas":"CAPEX/OPEX Curves",
            "costes":"Passthrough cost",
            "economicosh":"Economic data",
            "config":"CAPEX/OPEX Curves",
            "barridos": "Sensitivities",
            "ppa_venta":"PPA sales prices RES"
          },
          "modulo": {
            "electrolizador": {
              "titulo": "Electrolyzer",
              "pmin": "Minimum power (%)",
              "prend": "Annual degradation (%)",
              "cauxmn": "Electricity consumption BOP at standby (%)",
              "cauxmx": "Electricity consumption BOP during operation (%)",
              "cnag": "H2O consumption (l/kgH2)",
              "pcag": "H2O price (EUR/m3 H2O)",
              "capexf": "Fixed CAPEX electrolyzer (EUR)",
              "capexv": "Variable CAPEX electrolyzer (EUR/MW)",
              "opex": "Electrolyzer OPEX",
              "capex":"Electrolyzer CAPEX",
              "capexr": "Stack replacement CAPEX (EUR/MW)",
              "vutil": "Stack lifespan (hours)",
              "pelfija": "Fixed electrolyzer power (MW)",
              "degrad": "Degradation/1000h of operation",
              "capexvb": "Variable BOP CAPEX (EUR/MW electrolyzer)",
              "cagmax": "Maximum annual water consumption (hm³)",
              datos_operativos: "Operational data",
              datos_economicos: "Economic data",
              reemplazo:"Stack replacement CAPEX (kEUR/MW)",
            },
            "electrolizador_degrad": {
              "titulo": "Electrolyzer Degradation",
              titulo_tabla: "Electrolyzer degradation curve table",
              titulo_curva: "Electrolyzer degradation curve",
              uso_electrolizador:"Electrolyzer charge (%)",
              eficiencia_electrolizador: "Degradation (kWh/kg)",
              anadir_fila: "Add row",
              "tipo": "Type",
              "tr1": "tr1",
              "tr2": "tr2",
              "tr3": "tr3",
              "tr4": "tr4",
              "tr5": "tr5",
              "tr6": "tr6",
            },
            "electrolizador_rend": {
              "titulo": "Electrolyzer Efficiency",
              titulo_tabla: "Electrolyzer efficiency curve table",
              titulo_curva: "Electrolyzer efficiency curve",
              uso_electrolizador:"Electrolyzer charge (%)",
              eficiencia_electrolizador: "Efficiency (kWh/kg)",
              anadir_fila: "Add row",
              "tipo": "Type",
              "tr1": "tr1",
              "tr2": "tr2",
              "tr3": "tr3",
              "tr4": "tr4",
              "tr5": "tr5",
              "tr6": "tr6",
            },
            planta_electrolisis: {
              titulo: "Electrolysis plant",
              usar_curvas_bop: "Use general CAPEX/OPEX (curves)",
              sabado_l:"Working saturday",
              domingo_l:"Working sunday",
              datos_operativos: "Operational data",
              datos_economicos: "Economic data",
              cauxmn: "BOP electricity consumption in standby (%)",
              cauxmx: "BOP electricity consumption during operation (%)",
              dimducto: "Duct length (km)",
              dimconexelec: "Electrical connection length (km)",
              dimtube: "Number of tube-trailers (KgH2)",
              capex: "BOP CAPEX",
              opex: "BOP OPEX",
              capexf: "Fixed BOP CAPEX",
              capexv: "Variable BOP CAPEX",
              opexf: "Fixed BOP OPEX",
              opexv: "Variable BOP OPEX",
              capexcel:"Electrical connection CAPEX of the electrolysis plant",
              opexcel:"Electrical connection OPEX of the electrolysis plant",
              capexfcel:"Fixed CAPEX of the electrical connection",
              capexvcel:"Variable CAPEX of the electrical connection",
              opexfcel:"Fixed OPEX of the electrical connection",
              opexvcel:"Variable OPEX of the electrical connection",
              capexduc: "Duct CAPEX calculation result (kEUR)",
              opexduc: "Duct OPEX calculation result (kEUR/year)",
              capexele: "Electrical connection CAPEX calculation result (kEUR)",
              opexele: "Electrical connection OPEX calculation result (kEUR/year)",
              capextra: "Tube-trailer CAPEX calculation result (kEUR)",
              opextra: "Tube-trailer OPEX calculation result (kEUR/year)",
              otros:"Others",
              h_ini:"Initial work hour from ",
              h_fin:"Final work hour until",
            },
            
            "almacenamiento": {
              "titulo": "Storage",
              "pdia": "Static losses (%/day)",
              piny:"Injection losses (%/kg H2)",
              "pext": "Extraction losses (%/kg H2)",
              "capexf": "Fixed CAPEX storage (EUR)",
              "capexv": "Variable CAPEX storage (EUR/ton H2)",
              "calmfija": "Fixed storage capacity (ton H2)",
              "cmax": "Maximum storage capacity (ton H2)",
              "opex": "Storage OPEX",
              "capex":"Storage CAPEX",
            },
            "bateria": {
              "titulo": "Battery",
              "pmax": "Maximum power (MW)",
              "capac": "Capacity (h)",
              "rend": "Efficiency (%)",
              "capexf": "Fixed CAPEX battery (EUR)",
              "capexv": "Variable CAPEX battery (EUR/MW)",
              "opex": "Battery OPEX",
              "capex":"Battery CAPEX",
              "degrad": "Annual degradation (%)",
              "vutil": "Battery lifespan (years)",
              "reempu": "Battery replacement CAPEX (% of CAPEX)",
              "emin": "Minimum battery energy (p.u.)",
              "emax": "Maximum battery energy (p.u.)",
              "pbatfija": "Fixed battery power (MW)",
              "poiv" :"Battery market access selling capacity (MW)"
            },
            "fotovoltaica": {
              "titulo": "Photovoltaic",
              "hora": "Hour",
              "perfil": "Profile (p.u.)",
              "poi": "POI (MW)",
              "capexf": "Fixed CAPEX photovoltaic (EUR)",
              "capexv": "Variable CAPEX photovoltaic (EUR/MW)",
              "opex": "Photovoltaic OPEX",
              "capex":"Photovoltaic CAPEX",
              "degrad": "Annual degradation (%)",
              "ppvfija": "Fixed photovoltaic power (MW)",
              "pmax": "Maximum photovoltaic power (MW)",
              capexcel:"Electrical connection CAPEX of the PV plant",
              opexcel:"Electrical connection OPEX of the PV plant",
              capexfcel:"Fixed CAPEX of the electrical connection",
              capexvcel:"Variable CAPEX of the electrical connection",
              opexfcel:"Fixed OPEX of the electrical connection",
              opexvcel:"Variable OPEX of the electrical connection",
            },
            "eolica": {
              "titulo": "Wind",
              "hora": "Hour",
              "perfil": "Profile (p.u.)",
              "poi": "POI (MW)",
              "capexf": "Fixed CAPEX wind (EUR)",
              "capexv": "Variable CAPEX wind (EUR/MW)",
              "opex": "Wind OPEX",
              "capex":"Wind CAPEX",
              "peolfija": "Fixed wind power (MW)",
              "pmax": "Maximum wind power (MW)",
              capexcel:"Electrical connection CAPEX of the wind plant",
              opexcel:"Electrical connection OPEX of the wind plant",
              capexfcel:"Fixed CAPEX of the electrical connection",
              capexvcel:"Variable CAPEX of the electrical connection",
              opexfcel:"Fixed OPEX of the electrical connection",
              opexvcel:"Variable OPEX of the electrical connection",
            },
            "ppa_configuracion": {
              "titulo": "PPA Configuration",
              "ppa": "PPA",
              "capmax": "Maximum contracted amount (MW)",
              "pcio": "PPA purchase price (EUR/MWh)",
              "pcio_venta": "PPA sale price (EUR/MWh)",
              "pcio_compra":"PPA purchase price (EUR/MWh)",
              "mensaje_check":"Indicate via the checkbox whether the corresponding PPA is valid in that year",
              "horas": "Usage hours (h)",
              "cppafija": "Fixed PPA power (MW)",
              activo1:"Active1",
              activo2:"Active2",
              activo3:"Active3"
            },
            "ppa_perfiles": {
              "titulo": "Profiles",
              titulo1:"PPA1",
              titulo2:"PPA2",
              titulo3:"PPA3",
              "hora": "Hour",
              "ppa1": "PPA1 (p.u.)",
              "ppa2": "PPA2 (p.u.)",
              "ppa3": "PPA3 (p.u.)"
            },
            ppa_venta:{
            titulo: "PPA Sale Prices RES",
            anio: "Year",
            pcppapv: "Fixed solar sale price",
            pcppaeol: "Fixed wind sale price",
            modo_min_pool: "Use minimum value between pool price and entered value",
            modo_valor: "Use entered value"
          },

            gen: {
              poic: "Consumption POI (MW)",
              poiv: "Injection POI (MW)",
              poiv_pv_venta: "Access power for PV sales",
              poiv_eol_venta: "Access power for wind sales",
              poiv_res_conjunta: "Joint RES export access capacity",
              poiv_res: "RES export access capacity (MW)",
              "opc_poic": "Purchase access capacity",
              "opc_poic_opt": "Optimize purchase access capacity",
              "opc_poic_fix": "Fixed purchase access capacity",
              "poicmin": "Minimum purchase access capacity",
              "poicmax": "Maximum purchase access capacity",
              "poicfij": "Fixed purchase access capacity",
              "pcpoic": "Purchase access capacity price (EUR/MW)"
            },            
            "demanda": {
              "titulo": "Demand",
              "subtitulo":"Green hydrogen",
              "alerta":"La demanda de hidrógeno low-carbon se encuentra deshabilitada al tratarse de una simulación off-grid. (si se puede, poner low-carbon y off-grid en cursiva)",
              OPC_LCOHLC_activado:"Low-carbon demand",
              OPC_LCOHLC_desactivado:"Monetize the low-carbon byproduct as an additional revenue stream",
              H2VOb: "Initial price for mandatory green H2 demand (EUR/kgH2)",
              H2VOp: "Initial price for optional green H2 demand (EUR/kgH2)",
              H2LOb: "Initial price for mandatory low carbon H2 demand (EUR/kgH2)",
              H2LOp: "Initial price for optional low carbon H2 demand (EUR/kgH2)",
              aplicar_inflacion:"Apply inflation",
              "tabla": {
                "id": "id",
                "dH2Ob": "Compulsory demand green H2 (ton H2)", 
                "pcH2Ob": "Compulsory demand price green H2 (EUR/kgH2)",
                "dH2Op": "Maximum optional demand green H2 (ton H2)",
                "pcH2Op": "Optional demand price green H2 (EUR/kgH2)",
              }
            },
            "demanda_lc": {
              "titulo": "Demand",
              "subtitulo":"Low carbon hydrogen",
              "tabla": {
                "id": "id",
                "dH2Ob": "Compulsory demand low carbon H2 (ton H2)", 
                "pcH2Ob": "Compulsory demand price low carbon H2 (EUR/kgH2)",
                "dH2Op": "Maximum optional demand low carbon H2 (ton H2)",
                "pcH2Op": "Optional demand price low carbon H2 (EUR/kgH2)",
                "dmH2Oex":"Maximum excess low carbon H2 demand (ton H2)",
                "pcH2Oex":"Excess low carbon H2 demand price",
              }
            },
            datos_anuales:{
              titulo: "Annual Data",
              tabla:{
                anio:"Year",
                emisiones:"H2 Emissions (gCO2/MJ)",
                GHG: "GHG (gCO2/MJ)",
                RES: "RES (%)",
                precio_limite: "Market Purchase Price Cap (EUR/MWh)",
                correlacion: "Correlation",
                precio_garantia: "Electricity Guarantee of Origin Price (EUR/MWh)",
                opcion_mensual_true:"Monthly",
                opcion_mensual_false:"Hourly",
              }
              
              
            },
            datos_economicos_hidrog:{
              titulo: "Economic Data",
              tabla:{
                anio:"Year",
                impcomc:"Purchase marketing tax (%)",
                ccomv: "Electricity sales tax (%)",
                pgdoe: "Electric GDOs (EUR/MWh)",
              }
            },
            "precios": {
              "titulo": "Prices (EUR/MWh)",
              "hora": "Hour",
            },
            peajes:{
              titulo: "Tolls",
              selec_pais:"Country",
              selec_tarif:"Fee",
              termino_ene:"Energy term ",
              termino_pot:"Power term ",
              country_esp:"Spain",
              country_pt:"Portugal",
              grupo_t:"Tariff group",
              switch_1:"Use charges",
              switch_2:"Use passthrough hourly profile",

              termino_p:"Toll term ",
              termino_pot_p:"Power toll term",
              termino_c:"Charge term ",
              termino_pot_c:"Power charge term",
              tipo:"Type",
              energia:"Energy (EUR/kWh)",
              potencia:"Power (EUR/kW year)",
              subida_anual: "Annual increase (% over the initial value)",
              valor_inicial_passthrough:"Hourly passthrough value",
            },
            datos_economicos: {
              titulo: "CAPEX",
              reparto_capex_h2: "% CAPEX H2 plant",
              reparto_capex_fv: "% CAPEX solar PV plant",
              reparto_capex_eol: "% CAPEX wind plant",
              anio_inicio_capex: "CAPEX Start Year",
              reparto_CAPEX: "CAPEX Distribution",
              error: "The sum must be equal to 100%",
              anio: "Year",
              porcentaje_CAPEX: "% CAPEX",
              anio_inicio: "Year",
              titulo_tabla: "CAPEX Subsidies",
              columna_subvencion: "Subsidies kEUR",
              columna_subv_RFNBO:"Subsidies €/kg of RFNBO H₂ produced"
          },

            curvas_CAPEXOPEX: { 
              capex_opex_curvas: "Use general CAPEX/OPEX (curves)",
              capex_opex_especifico: "Use specific CAPEX/OPEX values",
              opex_anual:"Use annual Opex path",
              switch_curvas: "Use curves",
              switch_especificos:"Use specific values",
              variable: "Variable",
              fijo: "Fixed",
              variable_units:"Variable (kEUR/MW year)",
              fijo_units:"Fixed (kEUR year)",
              opex_anual_title:"Anual opex",
              precio_transferencia_interno:"Internal transfer price (EUR/MWh)",
            },
            "ejecucion": {
              "titulo": "Simulation Design",  
              "anio_inicio": "COD year",
              "anio_inicio_solar": "COD solar PV year",
              "anio_inicio_eolica": "COD wind year",
              "anio_fin": "End year",
              "anio_ejec":"Years of operation",
              "mes_inic":"Initial month",
              "mes_inic_solar":"Initial month solar PV",
              "mes_inic_eolica":"Initial month wind",
              "OPC_EJEC": "Target",           
              "OPC_MIP": "OPC_MIP", 
              "OPC_MCDO": "Market options",           
              "OPC_PV": "Phovoltaic plant options",
              "OPC_EL": "Electrolyzer options",
              "OPC_BAT": "Battery options",
              "OPC_VBAT": "Allow battery sales to market",
              
              "OPC_ALM": "Hydrogen storage options",
              "OPC_EOL": "Wind plant options",
              "OPCDEM_A": "Annual demand mode", 
              "OPCDEM_M": "Monthly demand mode", 
              "OPCDEM_D": "Daily demand mode", 
              "TASA_DCTO": "Discount rate (%)",
              "subtitulo_horario":"Hydrogen plant production schedule",
              "INFL_COD":"Base inflation year" ,
              "TASA_INFL": "Annual inflation (%)",
              "OPC_AMORT": "Consider depreciation for LCOH",
              "LIMIT_MCDO": "Market purchase price limit (EUR/MWh)",
              "OPC_PPA": "PPAs options", 
              "OPT_ALM": "Optimize storage", 
              "IMPTO_SOC":"Corporate tax",   
              "FV_FIJA":"Use fixed price for solar energy sales",
              "EO_FIJA":"Use fixed price for wind energy sales",
              "pcppapv": "Precio fijo venta solar",
              "pcppaeol": "Precio fijo venta eólica",
              "ANIO_PPA_INI":"PPA initial year",
              "ANIO_PPA_FIN":"PPA end year",
              "opciones": {

                meses: {
                  enero: 'January',
                  febrero: 'February',
                  marzo: 'March',
                  abril: 'April',
                  mayo: 'May',
                  junio: 'June',
                  julio: 'July',
                  agosto: 'August',
                  septiembre: 'September',
                  octubre: 'October',
                  noviembre: 'November',
                  diciembre: 'December',
                },
                "lcoh_min": "Minimize LCOH",
                "npv_max": "Maximize NPV",
                "no_limit": "Unlimited market purchase",
                "price_limit": "Purchase for electrolyzer with price limit",
                "compra_mercado" :"Market purchase",
                "buy_aux": "Market purchase for BOP only",
                "off_grid": "Not connected to the grid (off-grid project)",
                "no_pv": "No solar photovoltaic plant",
                "opt_pv": "Optimize solar photovoltaic plant",
                "pv_fix_cap": "Fixed solar photovoltaic plant",              
                "no_eol": "No wind plant",
                "opt_eol": "Optimize wind plant",
                "eol_fix_cap": "Fixed wind plant",   
                
                no_bat :"No battery",
                opt_bat:"Optimize battery",
                bat_fix_cap:"Fixed battery",   

                no_alm: "No storage",
                opt_alm: "Optimize storage",
                alm_fix: "Fixed storage",

                opt_elec: "Optimize electrolyzer",
                elec_fix: "Fixed electrolyzer",

                no_ppas: "No PPAs",
                opt_ppas: "Optimize PPAs",
                ppas_fix: "Fixed PPAs",

                OPC_AMORT_si:"Si",
                OPC_AMORT_no:"No",

              },
              "tabla": {
                "ppa": "PPA",
                "cppafija": "Fixed PPA power (MW)"
              },
              switch: {
                ducto: "Use duct?",
                conexion: "Use electric connection",
                tt: "Use tube-trailers?",
                span: "The electric connection is not available in Off-grid mode",
              }
            },
            "resultado": {
              "titulo": "Result",
              titulo_diseno: "Design",
              titulo_resumen:"Summary",
              titulo_economico:"Economic Result",
              titulo_variables: "Variables",
              titulo_temporalidad:"Temporary data",
              horizonte_completo:"Full horizon",
              cargar_grafico:"Graphic load of H2 production",

              parametro: "Parameter",
              valor: "Value",
              codigo_colores:"Colour code:",
              variable:"Variable",
              unidad:"Unit",

              general:"General",
              energia:"Energy",
              planta_electrolisis:"Electrolysis plant",
              electrolizador:"Electrolyzer",
              almacenamiento_hidrogeno:"Hydrogen storage",
              baterias:"Batteries",
              demanda:"Demand",
              param_econ:"Economic Parameters",
              
  

              "PI_EL": "Electrolyzer power (MW)",
              "CAP_ALM": "Storage capacity (ton H2)",
              "PC_PPA1": "Contracted power PPA1 (MW)",
              "PC_PPA2": "Contracted power PPA2 (MW)",
              "PC_PPA3": "Contracted power PPA3 (MW)",
              "PI_BAT": "Battery power (MW)",
              "PI_PV": "Photovoltaic solar plant power (MW)",
              "PI_EOL": "Wind plant power (MW)",
              "LCOH": "LCOH (EUR/kgH2)",
              "HFUN": "Electrolyzer operating hours (h)", 
              "HEQ":"Electrolyzer equivalent hours (h)",
              
              "resumen": {
                "intervalo": "Operating horizon",
                "mes_inicio": "Initial month",
                "reparto_capex":"CAPEX distribution",
                "total_anios": "Total Years",
                "funcion_objetivo": "Objective Function",
                "modo_de_aprovisionamiento": "Supply Mode",
                "opciones_del_electrolizador": "Electrolyzer Options",
                "opciones_del_almacenamiento": "Storage Options",
                "opciones_solar_fotovoltaica": "Photovoltaic Solar Options",
                "opciones_eolica": "Wind Power Options",
                "opciones_bateria": "Battery Options",
                "opciones_venta_bateria": "Allow battery sales to market",
                "opciones_ppa": "PPA Options",
                "opciones_poic":"Purchase access options",
                "opciones_demanda": "Demand Options",
                "lcoh": "LCOH",
                "npv": "NPV",
                "poic_c":"Access power",
                "energia_comprada_a_mercado": "Energy Purchased from Market",
                "potencia_contratada_ppa1": "PPA1 Contracted Power",
                "energia_consumida_ppa1": "PPA1 Consumed Energy",
                "energia_vendida_ppa1": "Sold Energy PPA1",
                "potencia_contratada_ppa2": "PPA2 Contracted Power",
                "energia_consumida_ppa2": "PPA2 Consumed Energy",
                "energia_vendida_ppa2": "Sold Energy PPA2",
                "potencia_contratada_ppa3": "PPA3 Contracted Power",
                "energia_consumida_ppa3": "PPA3 Consumed Energy",
                "energia_vendida_ppa3": "Sold Energy PPA3",
                "potencia_instalada_planta_solar_fotovoltaica": "Installed Power of PV Solar Plant",
                "energia_producida_planta_solar_fotovoltaica": "Energy Produced by PV Solar Plant",
                "energia_consumida_planta_solar_fotovoltaica": "Energy consumed by PV Solar Plant",
                "vertidos_fv":"Photovoltaic solar plant discharges",
                "energia_vendida_pv":"Solar energy market sales",
                "potencia_instalada_planta_eolica": "Installed Power of Wind Plant",
                "energia_producida_planta_eolica": "Energy Produced by Wind Plant",
                "energia_consumida_planta_eolica": "Energy consumed by Wind Plant",
                "vertidos_eolica":"Wind plant discharges",
                "energia_vendida_eol":"Wind energy market sales",
                "potencia_nominal_electrolizador": "Electrolyzer Nominal Power",
                "potencia_minima_electrolizador": "Electrolyzer Minimum Power",
                "horas_de_funcionamiento_electrolizador": "Electrolyzer Operating Hours",
                "horas_equivalentes_electrolizador":"Electrolyzer equivalent hours",
                "degradacion_anual_electrolizador": "Electrolyzer Annual Degradation",
                "sustitucion_stacks_electrolizador": "Electrolyzer Stack Replacement",
                "consumo_de_agua_electrolizador": "Electrolyzer Water Consumption",
                "consumo_energia_electrolizador": "Electrolyzer Energy Consumption",
                "produccion_RFNBO":"RFNBO production",
                "produccion_Low_carbon":"Low Carbon production",
                "consumo_energia_bop": "BOP Energy Consumption",
                "capacidad_de_almacenamiento_de_hidrogeno": "Hydrogen Storage Capacity",
                "perdidas_estaticas_almacenamiento_hidrogeno": "Hydrogen Storage Static Losses",
                "perdidas_por_inyeccion_almacenamiento_hidrogeno": "Hydrogen Storage Injection Losses",
                "perdidas_por_extraccion_almacenamiento_hidrogeno": "Hydrogen Storage Extraction Losses",
                "potencia_baterias": "Batteries Power",
                "duracion_baterias": "Batteries Duration",
                "capacidad_de_almacenamiento_baterias": "Batteries Storage Capacity",
                "rendimiento_baterias": "Batteries Efficiency",
                "degradacion_anual_baterias": "Batteries Annual Degradation",
                "vida_util_baterias": "Batteries Lifespan",
                "consumo_energia_baterias": "Batteries Input Energy",
                "produccion_energia_baterias": "Batteries-to-ELY energy",
                "energia_vendida_baterias":"Batteries-to-Market Energy",
                "demanda_obligatoria": "Mandatory RFNBO H2 Demand",
                "precio_demanda_obligatoria": "Mandatory RFNBO H2 Demand Price",
                "demanda_obligatoria_lc": "Mandatory low carbon H2 Demand",
                "precio_demanda_obligatoria_lc": "Mandatory no RFNBO H2 Demand Price",
                "demanda_opcional": "Optional RFNBO H2 Demand",
                "precio_demanda_opcional": "Optional RFNBO H2 Demand Price",
                "demanda_opcional_lc": "Optional low carbon H2 Demand",
                "precio_demanda_opcional_lc": "Optional no RFNBO H2 Demand Price",
                "demanda_H2_no_suministrada":"H2 demand not supplied",
                "demanda_H2_no_atendida_RFNBO": "Unserved RFNBO H2 demand",
                "demanda_H2_no_atendida_LC": "Unserved low carbon H2 demand",
                "capex_electrolizador": "Electrolyzer CAPEX",
                "capex_reemplazo_stacks_electrolizador": "Electrolyzer Stack Replacement CAPEX",
                "capex_almacenamiento": "Storage CAPEX",
                "capex_poic":"CAPEX access power",
                "capex_baterias": "Batteries CAPEX",
                "capex_reemplazo_stacks_baterias": "Batteries Stack Replacement CAPEX",
                "capex_planta_solar_fotovoltaica": "PV Solar Plant CAPEX",
                "capex_planta_eolica": "Wind Plant CAPEX",
                "capex_subv":"Subsidy CAPEX",
                "capex_subv_uni":"CAPEX subsidies per unit",
                "capex_total": "Total CAPEX",
                "coste_ppa1": "PPA1 Cost",
                "coste_ppa2": "PPA2 Cost",
                "coste_ppa3": "PPA3 Cost",
                "coste_ppa1_p": "PPA1 pass-through cost",
                "coste_ppa2_p": "PPA2 pass-through cost",
                "coste_ppa3_p": "PPA3 pass-through cost",
                "coste_ppa1_i": "PPA1 electricity tax cost",
                "coste_ppa2_i": "PPA2 electricity tax cost",
                "coste_ppa3_i": "PPA3 electricity tax cost",
                "coste_energia_a_mercado": "Energy Market Cost",
        
               "coste_energia_a_mercado_P": "Passthrough market cost",
               "coste_energia_a_mercado_I": "Grid electricity market tax cost",
                "coste_impuesto_PV": "PV electricity tax cost",
                "coste_impuesto_EOL": "Wind electricity tax cost",
                "coste_tarifas": "Tariffs Cost",
                "coste_tarifas_e":"Energy tolls and charges cost",
                "coste_tarifas_p":"Power tolls and charges cost",
                "coste_gdo":"cost of electricity GOs",
                "coste_agua": "Water Cost",
                "valor_no_RFNBO": "Low carbon valorization",
                "coste_operacion_y_mantenimiento_total": "Total Operation & Maintenance Cost",
                "coste_total": "Total Cost",
                "ingreso_demanda_obligatoria": "Mandatory Demand Revenue",
                "ingreso_demanda_obligatoria_verde": "Mandatory RFNBO Demand Revenue",
                "ingreso_demanda_obligatoria_lowcarbon": "Mandatory low carbon Demand Revenue",

                "ingreso_demanda_opcional": "Optional Demand Revenue",
                "ingreso_demanda_opcional_verde": "Optional RFNBO Demand Revenue",
                "ingreso_demanda_opcional_lowcarbon": "Optional low carbon Demand Revenue",
                "ingreso_planta_solar_fotovoltaica": "PV Solar Plant Revenue",
                "ingreso_planta_eolica": "Wind Plant Revenue",
                "ingreso_ppa1": "PPA1 Revenue",
                "ingreso_ppa2": "PPA2 Revenue",
                "ingreso_ppa3": "PPA3 Revenue",
                "ingreso_bateria":"Batteries Revenue",
                "inflacion_anual": "Annual Inflation",
                "tasa_de_descuento": "Discount Rate",
                "consumo_electricidad_bop":"BOP energy consumption during shutdown",
                "consumo_electricidad_compresor":"Compressor energy consumption",
                "capex_bop":"CAPEX BOP",
                "opex_total":"Total OPEX ",
                "capex_ducto":"Duct CAPEX ",
                "capex_con":"Electricity connection CAPEX",
                "capex_tube":"Tube-trailers CAPEX "
              },

              "flujos-caja": {
                "titulo": "CAPEX/OPEX Summary",
                "tab": "Economic results",
                "titulo-tabla": "Summary table",
                "tabla_cashflow": "Cashflow table",
                "tabla_anio": "Year",
                "tabla_capex": "CAPEX",
                "tabla_capex-revamping": "CAPEX Revamping",
                "tabla_subvencion": "Subsidy",
                "tabla_subvencion_uni": "Subsidies per unit",
                "tabla_capex-res": "CAPEX RES",
                "tabla_opex-electrico": "Electric OPEX",
                "tabla_opex-h2": "OPEX H2 plant",
                "tabla_opex-res": "OPEX RES",
                "tabla_ingresos-electrico": "Electric revenues",
                "tabla_otros":"Other revenues",
                "tabla_ingresos-h2-verde": "Green H2 revenues",
                "tabla_ingresos-h2-lowcarbon": "Low-carbon H2 revenues",
                "tabla_cf-total": "Total CF",
                "grafica_cascada": "Waterfall chart",
                "lcoe_pv": "LCOE solar PV",
                "lcoe_eolica": "LCOE wind",
                "graficas": {
                  "capex": "CAPEX",
                  "capexRevamping": "CAPEX Revamping",
                  "subvencion": "Subsidy",
                  "subvencion_uni":"Subsidies per unit",
                  "capexRES": "CAPEX RES",
                  "opexElec": "OPEX electricity",
                  "opexH2": "OPEX H2 plant",
                  "opexRES": "OPEX RES",
                  "ingresosElec": "Electricity revenues",
                  "otrosIngresos":"Other revenues",
                  "ingresosH2verde": "Green H2 revenues",
                  "ingresosH2lowcarbon": "Low-carbon H2 revenues",
                  "ingresosVallowcarbon": "Low-carbon valorization revenues",
                  "cfTotal": "Total CF",
                  "LCOH":"LCOH",
                  "amortizacion":"Amortization",
                  "aumento":"Increase",
                  "disminucion":"Decrease",
                  "total":"Total",
                }

            },
            "periodo-tarifario": {
              "tab": "Tariff periods",
              "titulo": "Annual contracted power by tariff periods",
              "anio": "Year",
              "p1": "Period 1 (h)",
              "p2": "Period 2 (h)",
              "p3": "Period 3 (h)",
              "p4": "Period 4 (h)",
              "p5": "Period 5 (h)",
              "p6": "Period 6 (h)",
              p1_mw:"Period 1 (MW)",
              p2_mw:"Period 2 (MW)",
              p3_mw:"Period 3 (MW)",
              p4_mw:"Period 4 (MW)",
              p5_mw:"Period 5 (MW)",
              p6_mw:"Period 6 (MW)",
              "titulo_utilizacion":"Usage of tariff periods"
            },
             "temporal": {
          "botones": {
            "aplicar": "Apply"
          },
          "filtros": {
            "tipo_periodo": "Period Type",
            "seleccionar_periodos": "Select Periods",
            "seleccionar_mes": "Select Month",
            "seleccionar_semana": "Select Week",
            "seleccionar_dias_semana": "Select Weekdays",
            "seleccionar_anios": "Select Years"
          },
          "periodos": {
            "mensual": "Monthly",
            "trimestral": "Quarterly",
            "anual": "Yearly",
            "semanal": "Weekly"
          },
          "mes": {
            "enero": "January",
            "febrero": "February",
            "marzo": "March",
            "abril": "April",
            "mayo": "May",
            "junio": "June",
            "julio": "July",
            "agosto": "August",
            "septiembre": "September",
            "octubre": "October",
            "noviembre": "November",
            "diciembre": "December"
          },
          "trimestre": {
            "t1": "Q1",
            "t2": "Q2",
            "t3": "Q3",
            "t4": "Q4"
          },
          "semana": {
            "1": "Week 1",
            "2": "Week 2",
            "3": "Week 3",
            "4": "Week 4"
          },
          "dia_semana": {
            "lunes": "Monday",
            "martes": "Tuesday",
            "miercoles": "Wednesday",
            "jueves": "Thursday",
            "viernes": "Friday",
            "sabado": "Saturday",
            "domingo": "Sunday"
          },
          "unidades": {
            "mwh": "MWh",
            "ton_h2": "ton H2"
          },
          "graficas": {
            "h2_origen": {
              "titulo": "Hr. H2 Production: RFNBO & Low Carbon"
            }
          },
          "origen": {
            "grid_verde": "GRID no RFNBO",
            "grid_rfnbo": "GRID RFNBO",
            "grid":"GRID",
            "ppa_verde_rfnbo": "PPA",
            "res_verde_rfnbo": "RES",
            "total_verde_rfnbo":"Total RFNBO + no RFNBO hr",
            "total_rfnbo":"RFNBO",
            "total_no_rfnbo":"No RFNBO"
          },
          "series": {
            "total_h2": "Total H2",
            "h2_verde": "Green H2",
            "h2_low_carbon": "Low-carbon H2"
          },
          "mensajes": {
            "aplicando_filtros": "Applying filters...",
            "cargando": "Loading...",
            "cargando_grafico": "Loading chart...",
            "preparando_datos": "Preparing data..."
          }
        }

              

            }
            
          }
          
        },
        barridos: {
          titulo: "Sensitivities IDs",
          boton_descargar_in: "Download IN",
          boton_lanzar: "Launch",
          boton_anadir: "Add",
          boton_descargar:"Download excel",
          boton_cerrar:"Close",
          resumen_titulo:"Simulation resumen",
          simulacion:"Simulation",
          titulo_grafica: "LCOH and NPV Comparison",
          eolica: "Wind",
          solar: "Solar",
          electrolizador: "Electrolyzer",
          potencia_eolica: "Wind power",
          potencia_solar: "Solar power",
          potencia_elec: "Electrolyzer power",
          valor_enter: "Add value and press Enter",
          inicial:"Initial",
          valores_iniciales:"Initial values",
          simulacion_original:"Original Simulation",
        },

        pestana_configuracion_general:{
          tab_curvas:"Curves",
          tab_coste:"Passthrough cost",
          tab_electrolizador:"Electrolizador",
          simulacion:"Base simulation",
        },
        config_costes:{
          titulo:"Passthrough cost",
          col_horas:"Hours",
          col_valores:"Passthrough cost (EUR/MWh)",
          descarga:"passthrough_cost",
        }, 
        pestana_configuracion: {
          guardar: "Save",
          anadir_fila: "Add row",
          electrolizador: "Electrolyzer",
          planta_fv: "Photovoltaic solar plant",
          planta_eolica: "Wind plant",
          bateria: "Battery",
          almacenamiento_hidrogeno: "Hydrogen storage",
          ducto: "Duct",
          conexion_electrica: "Electrical connection",
          tube_trailer: "Tube-trailer",
          capex_opex: "CAPEX and OPEX per unit",
          capex: "CAPEX (kEUR)",
          opex: "OPEX (kEUR/year)",
          nombres_curvas: {
            "Electrolizador": "Electrolyzer",
            "Planta solar fotovoltaica": "Photovoltaic solar plant",
            "Planta eólica": "Wind plant",
            "Batería": "Battery",
            "Almacenamiento de hidrógeno": "Hydrogen storage",
            "Ducto": "Duct",
            "Conexión eléctrica": "Electrical connection",
            "Tube-tráiler": "Tube-trailer",
            "BOP": "BOP"
          }
        },
        diagrama: {
          centro_operativo: "H₂ operating center",
          modulos: "Active module status",
          celdas: "Cells",
          online:"online",
          nodos: {
            resultados: "General results",
            indicador: "Indicator",
            valor: "Value",
            demanda_no_suministrada:"Unmet H2 demand",
            electricidad: "Electricity supply",
            hidrogeno: "H₂ production, storage and distribution",
            demanda: "Demand",
            compra:"Purchase",
            venta:"Sale",
            agua: "Water supply",
            conexion_electrica: "Electrical connection",
            electrolizador: "electrolyzer",
            eolica: "Wind",
            solar: "PV",
            compresor: "Compressor",
            almacen: "H₂ Storage",
            camion: "Tube trailers",
            tubo: "H₂ Pipeline",
            consumo: "Demand / Industry",
            grid: "Grid",
            ppas: "PPAs",
            bess: "BESS",
            demanda1: "🟢 RFNBO H₂ Demand",
            demanda2: "🟠 No RFNBO H₂ Demand"
          },
          conexiones: {
            agua: "Water",
            energia_eolica: "Wind energy",
            energia_solar: "Solar energy",
            h2_generado: "H₂ generated",
            h2_comprimido: "H₂ compressed",
            distribucion: "Distribution",
            suministro: "Supply",
            apoyo_electrico: "Electric support",
            contrato_ppas: "PPAs contract",
            contrato_bateria: "Battery contract"
          }
        }
        
        
      }
    
    

};



const i18n = createI18n({
  locale: 'es', // Idioma por defecto
  fallbackLocale: 'es', // Idioma de respaldo
  messages,
});

export default i18n;